import { combineReducers } from 'redux';

import { reducer as editor } from './editor/slice';

export default combineReducers({
    editor,
});
